export default __webpack_public_path__ + "static/instagram-5eb21ca648540f804588c34423989ab6.svg";